import {
    faCalendar,
    faShieldAlt,
    faExclamationTriangle,
    faClipboardList,
    faGavel,
    faCalendarAlt,
    faFolderOpen,
    faFile,
    faFileAlt,
    faFingerprint,
    faUser,
    faCogs,
    faDesktop,
    faNetworkWired,
    faGlobe,
    faCodeBranch,
    faBug,
    faBuilding,
    faUsers,
    faTasks
  } from "@fortawesome/free-solid-svg-icons";
import WebexCategorie from "../../../Webex/WebexCategorie";
import { t } from "i18next";

/**
 * 
 * @param {object} item - device from sentinelOne devices 
 */
export default function RowThreats({ item }) {
    const threatsStatus = {
        detailsThreats: [
            { value: item["Threat Name"], title: t("Nom de la menace"), multiple: false, number: false, iconType: "fontAwesome", icon: faCalendar },
            { value: item["Classification"], title: t("Classification"), multiple: false, number: false, iconType: "fontAwesome", icon: faShieldAlt },
            { value: item["Confidence Level"], title: t("Niveau de confiance"), multiple: false, number: false, iconType: "fontAwesome", icon: faExclamationTriangle },
            { value: item["Incident Status"], title: t("État de l'incident"), multiple: false, number: false, iconType: "fontAwesome", icon: faClipboardList },
            { value: item["Analyst Verdict"], title: t("Verdict de l'analyste"), multiple: false, number: false, iconType: "fontAwesome", icon: faGavel },
            { value: item["Date Identified"], title: t("Date d'identification"), multiple: false, number: false, iconType: "fontAwesome", icon: faCalendarAlt },
            { value: item["SHA1 Hash"], title: t("Empreinte SHA1"), multiple: false, number: false, iconType: "fontAwesome", icon: faFingerprint },
            { value: item["Process User"], title: t("Utilisateur du processus"), multiple: false, number: false, iconType: "fontAwesome", icon: faUser },
            { value: item["Originator Process"], title: t("Processus d'origine"), multiple: false, number: false, iconType: "fontAwesome", icon: faCogs },
            { value: item["File Size"] + ' ko', title: t("Taille du fichier"), multiple: false, number: false, iconType: "fontAwesome", icon: faFile },
            { value: item["File Extension Type"], title: t("Type d'extension de fichier"), multiple: false, number: false, iconType: "fontAwesome", icon: faFileAlt },
            { value: item["File Path"], title: t("Chemin du fichier"), multiple: false, number: false, iconType: "fontAwesome", icon: faFolderOpen }
        ],        
        detailsDevice: [
            { value: item["Agent Computer Name"], title: t("Nom de l'ordinateur"), multiple: false, number: false, iconType: "fontAwesome", icon: faDesktop },
            { value: item["Agent IP (Internal)"], title: t("Adresse IP interne"), multiple: false, number: false, iconType: "fontAwesome", icon: faNetworkWired },
            { value: item["Agent IP (External)"], title: t("Adresse IP externe"), multiple: false, number: false, iconType: "fontAwesome", icon: faGlobe },
            { value: item["Agent OS"], title: t("Système d'exploitation"), multiple: false, number: false, iconType: "fontAwesome", icon: faGlobe }, 
            { value: item["Agent Version"], title: t("Version de l'agent"), multiple: false, number: false, iconType: "fontAwesome", icon: faCodeBranch },
            { value: item["Active Threats"], title: t("Menaces actives"), multiple: false, number: true, iconType: "fontAwesome", icon: faBug },
            { value: item["Site"], title: t("Site"), multiple: false, number: false, iconType: "fontAwesome", icon: faBuilding },
            { value: item["Group"], title: t("Groupe"), multiple: false, number: false, iconType: "fontAwesome", icon: faUsers }
        ],
        statut: [
            { value: item["Mitigation Status Description"], title: t("Statut de mitigation"), multiple: false, number: false, iconType: "fontAwesome", icon: faShieldAlt },
            { value: item["Pending Actions"], title: t("Actions en attente"), multiple: false, number: false, iconType: "fontAwesome", icon: faTasks }
        ]
    }

    return (
        <>
            <div className="webex-resume">
                <WebexCategorie array={threatsStatus.detailsThreats} categorie={t("Identification du device")} />
            </div>
            <div className="webex-remuse">
                <WebexCategorie array={threatsStatus.detailsDevice} categorie={t("Réseau")} />
            </div>
            <div className="webex-resume">
                <WebexCategorie array={threatsStatus.statut} categorie={t("Matériels du système d'exploitation")} />
            </div>
        </>
    )
}